export class ConceptualModelClass {
    pimIri = null;
    /**
     * @deprecated use {@link iris} instead
     */
    cimIri = null;
    iris = [];
    humanLabel = null;
    humanDescription = null;
    isCodelist = false;
    codelistUrl = [];
    extends = [];
    properties = [];
    regex = null;
    example = null;
    objectExample = null;
    static getAllExtends(cls) {
        const result = new Set();
        const queue = [...cls.extends];
        while (queue.length > 0) {
            const current = queue.pop();
            if (!result.has(current)) {
                result.add(current);
                queue.push(...current.extends);
            }
        }
        return [...result];
    }
}
//# sourceMappingURL=conceptual-model-class.js.map